import { render, staticRenderFns } from "./categoryEditPage.vue?vue&type=template&id=ea220b76&scoped=true&"
import script from "./categoryEditPage.vue?vue&type=script&lang=js&"
export * from "./categoryEditPage.vue?vue&type=script&lang=js&"
import style0 from "./categoryEditPage.vue?vue&type=style&index=0&id=ea220b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea220b76",
  null
  
)

export default component.exports